import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch } from 'vue';
// 引入
import TEditor from '@/components/TEditor.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'NoEditor',
  props: {
    disabled: Boolean,
    editorValue: String,
    loading: Boolean
  },
  emits: ['update:editorValue', 'sendImageUrlMap', 'change', 'update:loading'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const EditorContent = ref();
    const editor = ref();
    const getContent = v => {
      emit('update:editorValue', v);
      emit('sendImageUrlMap', editor.value.uploadImageUrlMap);
      emit('change', v);
    };
    const changeLoading = value => {
      emit('update:loading', value);
    };
    watch(() => props.editorValue, (n, o) => {
      if (n !== o) {
        EditorContent.value = n;
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(TEditor, {
        ref_key: "editor",
        ref: editor,
        modelValue: EditorContent.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => EditorContent.value = $event),
        disabled: __props.disabled,
        onGetContent: getContent,
        loading: __props.loading,
        "onUpdate:loading": changeLoading
      }, null, 8, ["modelValue", "disabled", "loading"]);
    };
  }
});